var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            modal: true,
            "show-close": false,
            "append-to-body": true,
            size: "1120px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
          nativeOn: {
            click: function ($event) {
              return _vm.changeMembers($event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "flex between-header align-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex align-center" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "ident copy",
                              attrs: {
                                title: "点击复制工作项地址",
                                "data-clipboard-text": _vm.identAddress(),
                              },
                              on: { click: _vm.copy },
                            },
                            [_vm._v("#" + _vm._s(_vm.formData.ident))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100px" },
                              attrs: {
                                size: "small",
                                filterable: "",
                                disabled: !_vm.isOperable,
                                "collapse-tags": "",
                                placeholder: "状态",
                              },
                              on: { change: _vm.changeStatus },
                              model: {
                                value: _vm.formData.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "status", $$v)
                                },
                                expression: "formData.status",
                              },
                            },
                            _vm._l(_vm.statusOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c(
                            "el-dropdown",
                            { attrs: { trigger: "hover" } },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _c("i", {
                                  staticClass:
                                    "iconfont icongengduo2 fz30 pointer mb14",
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.addSubtasks(_vm.formData)
                                        },
                                      },
                                    },
                                    [_vm._v("新建子任务")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.copyTask($event)
                                        },
                                      },
                                    },
                                    [_vm._v("复制工作项")]
                                  ),
                                  _vm._v(" "),
                                  _vm.formData.operate
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.deleteTask($event)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "header header-item" }, [
            _c(
              "div",
              { staticClass: "title" },
              [
                !_vm.nameShow
                  ? _c("div", { ref: "title", staticClass: "name line3" }, [
                      _vm._v(_vm._s(_vm.formData.name)),
                    ])
                  : _c("el-input", {
                      staticClass: "input-item",
                      attrs: {
                        maxlength: "100",
                        "show-word-limit": "",
                        placeholder: "请输入任务名称",
                      },
                      on: { blur: _vm.handleName },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          _vm.nameShow = false
                        },
                      },
                      model: {
                        value: _vm.formData.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "name", $$v)
                        },
                        expression: "formData.name",
                      },
                    }),
                _vm._v(" "),
                !_vm.nameShow && _vm.isOperable
                  ? _c("i", {
                      staticClass: "iconfont iconbianji pointer",
                      on: {
                        click: function ($event) {
                          _vm.nameShow = true
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "creator" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.formData.creator ? _vm.formData.creator[0].name : ""
                  ) +
                    " · " +
                    _vm._s(_vm.formData.created_at) +
                    "，最近更新于" +
                    _vm._s(_vm.formData.updated_at)
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                "label-width": "84px",
                rules: _vm.rule,
              },
            },
            [
              _c(
                "div",
                { staticClass: "left-card" },
                [
                  _c(
                    "el-row",
                    { staticClass: "ml20" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "关联项目：",
                                prop: "program_id",
                              },
                            },
                            [
                              _c("div", { staticClass: "bg" }, [
                                !_vm.programShow
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "pointer p-l-12",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleToggle(
                                              "programShow"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.getProgramVal()))]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _vm.programShow
                                ? _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        size: "small",
                                        placeholder: "请选择关联项目",
                                        filterable: "",
                                      },
                                      on: { change: _vm.handleContract },
                                      model: {
                                        value: _vm.formData.program_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "program_id",
                                            $$v
                                          )
                                        },
                                        expression: "formData.program_id",
                                      },
                                    },
                                    _vm._l(_vm.projectList, function (item) {
                                      return _c(
                                        "el-option",
                                        {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _c("span", [
                                              _vm._v(_vm._s(item.label)),
                                            ]),
                                            _vm._v(" "),
                                            item.status == 1 || item.status == 2
                                              ? _c(
                                                  "span",
                                                  {
                                                    class:
                                                      item.status == 1
                                                        ? "program-stop"
                                                        : "program-close",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.status == 1
                                                          ? "已暂停"
                                                          : "已关闭"
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "select-bar",
                              attrs: { label: "负责人：" },
                            },
                            [
                              !_vm.adminsShow
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "admins pointer flex bg",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleToggle("adminsShow")
                                        },
                                      },
                                    },
                                    [
                                      _vm.formData.admins &&
                                      _vm.formData.admins.length == 0
                                        ? _c("div", { staticClass: "p-l-12" }, [
                                            _vm._v("未设置"),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.formData.admins,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "avatar-box p-l-12",
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: item.avatar,
                                                  alt: "",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(item.name)),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.adminsShow
                                ? _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        size: "small",
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请选择负责人",
                                      },
                                      on: { change: _vm.selectAdmins },
                                      model: {
                                        value: _vm.formData.uid,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "uid", $$v)
                                        },
                                        expression: "formData.uid",
                                      },
                                    },
                                    _vm._l(
                                      _vm.programMemberOptions,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "ml20" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "select-bar",
                              attrs: { label: "计划时间：" },
                            },
                            [
                              !_vm.timeValShow
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "bg pointer",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleToggle("timeValShow")
                                        },
                                      },
                                    },
                                    [
                                      _vm.formData.plan_start
                                        ? _c(
                                            "span",
                                            { staticClass: "p-l-12" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formData.plan_start
                                                ) +
                                                  " - " +
                                                  _vm._s(_vm.formData.plan_end)
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.formData.plan_start
                                        ? _c(
                                            "span",
                                            { staticClass: "p-l-12" },
                                            [_vm._v("未设置")]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.timeValShow
                                ? _c("el-date-picker", {
                                    attrs: {
                                      size: "small",
                                      type: "daterange",
                                      clearable: "",
                                      format: "yyyy-MM-dd",
                                      "value-format": "yyyy-MM-dd",
                                      placeholder: "请选择项目计划时间",
                                      "range-separator": _vm.$t("toptable.to"),
                                      "start-placeholder":
                                        _vm.$t("toptable.startdate"),
                                      "end-placeholder": _vm.$t(
                                        "toptable.endingdate"
                                      ),
                                    },
                                    on: {
                                      blur: function ($event) {
                                        _vm.timeValShow = false
                                      },
                                      change: _vm.onchangeTime,
                                    },
                                    model: {
                                      value: _vm.timeVal,
                                      callback: function ($$v) {
                                        _vm.timeVal = $$v
                                      },
                                      expression: "timeVal",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "select-bar",
                              attrs: { label: "协作者：" },
                            },
                            [
                              !_vm.membersShow
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "admins pointer flex bg",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleToggle("membersShow")
                                        },
                                      },
                                    },
                                    [
                                      _vm.formData.members &&
                                      _vm.formData.members.length == 0
                                        ? _c("div", { staticClass: "p-l-12" }, [
                                            _vm._v("未设置"),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.formData.members &&
                                      _vm.formData.members.length <= 3
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "avatar-box p-l-12",
                                            },
                                            _vm._l(
                                              _vm.formData.members.slice(0, 3),
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "members-box",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: item.avatar,
                                                        alt: "",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(_vm._s(item.name)),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.formData.members &&
                                      _vm.formData.members.length > 3
                                        ? _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                placement: "bottom-start",
                                                title: "其他协作者：",
                                                width: "260",
                                                trigger: "hover",
                                              },
                                            },
                                            [
                                              _vm.formData.members &&
                                              _vm.formData.members.length > 3
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "members-box",
                                                    },
                                                    _vm._l(
                                                      _vm.formData.members.slice(
                                                        3
                                                      ),
                                                      function (item, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "members-box",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: item.avatar,
                                                                alt: "",
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "members-box-content",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.name
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "p-l-12",
                                                  attrs: {
                                                    slot: "reference",
                                                    size: "small",
                                                  },
                                                  slot: "reference",
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.formData.members.slice(
                                                      0,
                                                      3
                                                    ),
                                                    function (item, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index,
                                                          staticClass:
                                                            "members-box",
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src: item.avatar,
                                                              alt: "",
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  !_vm.formData.members
                                                    ? _c("span", [
                                                        _vm._v("- -"),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.formData.members &&
                                                  _vm.formData.members.length >
                                                    3
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "contents",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "+ " +
                                                              _vm._s(
                                                                _vm.formData
                                                                  .members
                                                                  .length - 3
                                                              )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        size: "small",
                                        multiple: "",
                                        filterable: "",
                                        "collapse-tags": "",
                                        placeholder: "指派协作者",
                                      },
                                      model: {
                                        value: _vm.formData.membersId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "membersId",
                                            $$v
                                          )
                                        },
                                        expression: "formData.membersId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.programMemberOptions,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "content ml20" }, [
                    !_vm.describeShow
                      ? _c("div", { staticClass: "flex describe between" }, [
                          _c("span", [_vm._v("描述：")]),
                          _vm._v(" "),
                          _vm.isOperable
                            ? _c("i", {
                                staticClass: "iconfont iconbianji pointer",
                                on: {
                                  click: function ($event) {
                                    _vm.describeShow = true
                                  },
                                },
                              })
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.describeShow && _vm.formData.describe
                      ? _c("div", {
                          staticClass: "describe-box",
                          domProps: {
                            innerHTML: _vm._s(_vm.formData.describe),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.previewPicture($event)
                            },
                          },
                        })
                      : _c(
                          "div",
                          [
                            _c("ueditorFrom", {
                              ref: "ueditorFrom",
                              tag: "ueditor-form",
                              attrs: {
                                border: _vm.describeShow,
                                height: "400px",
                                headers: _vm.describeShow,
                                readOnly: !_vm.describeShow,
                                content: _vm.formData.describe,
                                placeholder: _vm.formData.describe
                                  ? ""
                                  : "无描述内容",
                              },
                              on: { input: _vm.ueditorEdit },
                            }),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _vm.describeShow
                      ? _c(
                          "div",
                          { staticClass: "ueditorBtn" },
                          [
                            _c(
                              "el-button",
                              { on: { click: _vm.cancelDescribe } },
                              [_vm._v("取消")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.submitDescribe },
                              },
                              [_vm._v("保存")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "comment" },
                    [
                      _c(
                        "el-tabs",
                        {
                          model: {
                            value: _vm.activeName,
                            callback: function ($$v) {
                              _vm.activeName = $$v
                            },
                            expression: "activeName",
                          },
                        },
                        [
                          _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: "评论(" + _vm.totalCount + ")",
                                name: "reply",
                              },
                            },
                            [
                              _c("comment", {
                                ref: "comment",
                                attrs: {
                                  pid: _vm.formData.pid,
                                  taskId: _vm.formData.id,
                                },
                                on: { gettotalCount: _vm.gettotalCount },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label:
                                  "操作日志(" + _vm.dynamicTotalCount + ")",
                                name: "dynamic",
                              },
                            },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.dynamicTaskList,
                                    "row-class-name": _vm.iconHadler,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { prop: "desc" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              "\n                    【" +
                                                _vm._s(
                                                  scope.row.action_type == 1
                                                    ? "创建"
                                                    : "编辑"
                                                ) +
                                                "】" +
                                                _vm._s(scope.row.operator) +
                                                "\n                    "
                                            ),
                                            _c("span", {
                                              staticStyle: {
                                                "max-width": "550px",
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  scope.row.title
                                                ),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.previewPicture(
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "created-time" },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.created_at)
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { type: "expand" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex expand-describe",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex expand-left",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.describe[0]
                                                            .title
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          scope.row.describe[0]
                                                            .value
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass: "line-short",
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex expand-right",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.describe[1]
                                                            .title
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          scope.row.describe[1]
                                                            .value
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right-card" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "父级任务：", prop: "path" } },
                    [
                      !_vm.pathShow
                        ? _c(
                            "div",
                            {
                              staticClass: "flex bg pointer pointer p-l-12",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleToggle("pathShow")
                                },
                              },
                            },
                            [
                              _vm.formData.parent
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.formData.parent.name)),
                                  ])
                                : _c("span", {}, [_vm._v("未设置")]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.pathShow
                        ? _c("el-cascader", {
                            attrs: {
                              options: _vm.programOptions,
                              props: { checkStrictly: true },
                              "collapse-tags": "",
                              clearable: "",
                              filterable: "",
                            },
                            on: { change: _vm.handleRemove },
                            model: {
                              value: _vm.formData.path,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "path", $$v)
                              },
                              expression: "formData.path",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "select-bar pointer",
                      attrs: { label: "优先级：" },
                    },
                    [
                      !_vm.priorityShow
                        ? _c(
                            "div",
                            {
                              staticClass: "flex align-center bg p-l-12",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleToggle("priorityShow")
                                },
                              },
                            },
                            [
                              _c("span", {
                                staticClass: "circle",
                                class: _vm.getClass(),
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.getVal()))]),
                            ]
                          )
                        : _c(
                            "el-select",
                            {
                              attrs: {
                                size: "small",
                                placeholder: "请选择优先级",
                              },
                              on: { change: _vm.changePriority },
                              model: {
                                value: _vm.formData.priority,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "priority", $$v)
                                },
                                expression: "formData.priority",
                              },
                            },
                            _vm._l(_vm.priorityOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formData.program_id
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "关联版本：", prop: "version_id" } },
                        [
                          !_vm.versionShow
                            ? _c(
                                "div",
                                {
                                  staticClass: "bg pointer set-version",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleToggle("versionShow")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "pointer p-l-12" },
                                    [_vm._v(_vm._s(_vm.getVersionVal()))]
                                  ),
                                  _vm._v(" "),
                                  _vm.programVersionList.length == 0 ||
                                  !_vm.formData.version_id
                                    ? _c("span", {}, [_vm._v("未设置")])
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.versionShow
                            ? _c(
                                "el-select",
                                {
                                  staticStyle: { width: "80%" },
                                  attrs: {
                                    size: "small",
                                    clearable: "",
                                    placeholder: "请选择关联版本",
                                    filterable: "",
                                  },
                                  on: { change: _vm.handleVersion },
                                  model: {
                                    value: _vm.formData.version_id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "version_id", $$v)
                                    },
                                    expression: "formData.version_id",
                                  },
                                },
                                _vm._l(_vm.programVersionList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isOperable
                            ? _c(
                                "span",
                                {
                                  staticClass: "pointer settings",
                                  on: { click: _vm.setVersion },
                                },
                                [_vm._v("设置")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            top: "13%",
            title: "版本设置",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleCloseVersion,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "draggable",
            {
              staticClass: "drag-area",
              on: {
                start: function ($event) {
                  _vm.dragging = true
                },
                end: function ($event) {
                  _vm.dragging = false
                },
              },
              model: {
                value: _vm.inputs,
                callback: function ($$v) {
                  _vm.inputs = $$v
                },
                expression: "inputs",
              },
            },
            _vm._l(_vm.inputs, function (input, index) {
              return _c(
                "div",
                { key: index, staticClass: "input-row" },
                [
                  _c("i", { staticClass: "iconfont icontuodong pointer" }),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { placeholder: "请输入版本名称" },
                    model: {
                      value: input.name,
                      callback: function ($$v) {
                        _vm.$set(input, "name", $$v)
                      },
                      expression: "input.name",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "pointer",
                      on: {
                        click: function ($event) {
                          return _vm.removeInput(index)
                        },
                      },
                    },
                    [_vm._v("-")]
                  ),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "add-input pointer", on: { click: _vm.addInput } },
            [
              _c("i", { staticClass: "el-icon-plus" }),
              _vm._v(" "),
              _c("span", [_vm._v("添加版本")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCloseVersion } }, [
                _vm._v("取 消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitVersion },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("image-viewer", {
        ref: "imageViewer",
        attrs: { "src-list": _vm.srcList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }